import { BIModel } from './BIModel';

export class MKTShareProductBIModel extends BIModel {

  static eventName = 'MKT_share_product';

  #productId;
  #channel;
  #flow;

  constructor(userId, productId, channel, flow) {
    super(MKTShareProductBIModel.eventName, userId);
    this.#productId = productId;
    this.#channel = channel;
    this.#flow = flow;
  }

  get productId() {
    return this.#productId;
  }
  
  get channel() {
    return this.#channel;
  }

  get flow() {
    return this.#flow;
  }
  
  get modelData() {
    return {
      product_id: this.productId,
      channel: this.channel,
      flow: this.flow
    };
  }  

}